// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"026ad976","585":"9ffb205e"}[chunkId] + ".chunk.js";
};